module.exports = __webpack_public_path__ + "static/media/Paper_Straws_SGS_pdf.c699fe1e.pdf";